import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { SyllabusQuery } from '@examdojo/category/v2';
import { distinctUntilChanged, filter, tap } from 'rxjs';
import { CmsUrlParts } from '../../cms/cms.model';

@Injectable()
export class NavigateOnActiveSyllabusChangeService {
  constructor(
    private readonly syllabusQuery: SyllabusQuery,
    private readonly router: Router,
  ) {
    this.navigateOnActiveSyllabusChange().pipe(takeUntilDestroyed()).subscribe();
  }

  navigateOnActiveSyllabusChange() {
    return this.syllabusQuery.selectActive().pipe(
      distinctUntilChanged((prev, curr) => prev?.id === curr?.id),
      filter(Boolean),
      tap((newSyllabus) => {
        // Get current URL and extract syllabusSlug from it
        const currentUrl = this.router.url;
        const urlMatch = currentUrl.match(new RegExp(`/${CmsUrlParts.Syllabus}/([^/]+)(/.*)?`));

        // Only navigate if we're currently in a syllabus route AND the slug is different
        if (urlMatch) {
          const currentSyllabusSlug = urlMatch[1];

          // Only navigate if the syllabusSlug is different
          if (currentSyllabusSlug !== newSyllabus.slug) {
            const remainingPath = urlMatch[2] || '';
            const newUrl = `/${CmsUrlParts.Syllabus}/${newSyllabus.slug}${remainingPath}`;
            this.router.navigateByUrl(newUrl);
          }
        }
      }),
    );
  }
}
